// extracted by mini-css-extract-plugin
export default {"container":"BlockSettings_container__tDcq3","content":"BlockSettings_content__VpMAm","tabs":"BlockSettings_tabs__Tt0cK","settingsGroups":"BlockSettings_settingsGroups__Cqd54"};